var _Rect, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function SvgFinish(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E1087E",
    rx: 15.5
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#E1087E",
    d: "M13 10h2V8h-2v2zm4 0V8h2v2h-2zm-4 8v-2h2v2h-2zm8-4v-2h2v2h-2zm0 4v-2h2v2h-2zm-4 0v-2h2v2h-2zm4-8V8h2v2h-2zm-6 2v-2h2v2h-2zm-5 12a.967.967 0 01-.713-.288A.968.968 0 019 23V9c0-.283.096-.52.287-.713A.968.968 0 0110 8c.283 0 .52.096.713.287.191.192.287.43.287.713v1h2v2h-2v2h2v2h-2v7a.97.97 0 01-.287.712A.968.968 0 0110 24zm9-8v-2h2v2h-2zm-4 0v-2h2v2h-2zm-2-2v-2h2v2h-2zm4 0v-2h2v2h-2zm2-2v-2h2v2h-2z"
  })));
}
export default SvgFinish;